module.exports = __webpack_public_path__ + "static/main_pic_01-c4b1ba4772303c9adfce92b6b8d9096e.jpg";